import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import SignUpForm from "./SignUpForm";
import { updateEvaluation } from "../../modules/evaluation/actions";
import { addAccount } from "../../modules/user/actions";

class SignUpFormContainer extends React.Component {

  componentDidMount() {
    if (this.props.user) {
      const type = window.location.pathname.split("/")[1];

      switch (type) {
        case "profile":
          this.props.history.push(
            `/profile/survey/${this.props.evaluationId}/results?step=REPORT`
          );
          break;

        case "twentyfivesections":
          this.props.history.push(
            `/twentyfivesections/survey/${this.props.evaluationId}/results?step=REPORT`
          );
          break;

        case "twelvesections":
          this.props.history.push(
            `/twelvesections/survey/${this.props.evaluationId}/results?step=REPORT`
          );
          break;

        case "360":
          this.props.history.push(
            `/360/survey/${this.props.evaluationId}/results?step=REPORT`
          );

          break;
        default:
      }
    }
  }

  render() {
    return (
      <SignUpForm
        {...this.props}
        addAccount={(
          email,
          password,
          name,
          age,
          education,
          experience,
          references
        ) =>
          this.props.addAccount(
            email,
            password,
            name,
            age,
            education,
            experience,
            references,
            this.props.evaluationId
          )
        }
        updateEvaluation={this.props.updateEvaluation}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    name: state.evaluation.fullName,
    age: state.evaluation.age,
    education: state.evaluation.educationalLevel,
    experience: state.evaluation.leadershipExp,
    references: state.evaluation.numberOfReferences,
    email: state.evaluation.email,
    password: state.evaluation.password,
    errorMessage: state.user.error,
    submitting: state.user.submitting || state.evaluation.submitting,
    evaluationId: state.evaluation.evaluationId,
    gotoSurvey: state.evaluation.gotoSurvey,
    user: state.user.user,
    language: state.preference.language
  };
}

const mapActionsToProps = {
  updateEvaluation,
  addAccount
};

export default withRouter(
  connect(
    mapStateToProps,
    mapActionsToProps
  )(SignUpFormContainer)
);



// WEBPACK FOOTER //
// ./src/pages/Evaluation/SignUpFormContainer.js